import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CustomLoader from 'Component/Common/CustomLoader';
import FormModal from 'Component/Common/Form/FormModal';
import { attachTreatment, getBranchSchedule, getSetupSchedule, attachDoctor } from 'Services/Features/Branch/Utils/branchUtils';
import { toast } from 'react-toastify';
import DetailContent from './DetailContent';
import ScheduleContent from '../CalendarGrid';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import ScheduleSetting from '../SetCalendarGridAdmin';
import AttachModal from 'Component/DashboardQeza/Branch/Form/AttachModal'; // Form-nya bisa dipisah juga kalau perlu
import SelectTreatment from '../SelectTreatment';
import SelectDoctor from '../SelectDoctor';
import SetupForm from '../SetupForm';
import { createSetupSchedule } from 'Services/Features/SetupSchedule/Utils/setupScheduleUtils';
import { resetFormData as resetBranchFormData, setFormData as setBranchFormData } from 'Services/Features/Branch/branchSlice';
import { resetFormData as resetScheduleFormData, setFormData as setScheduleFormData } from 'Services/Features/SetupSchedule/setupScheduleSlice';
import BranchTreatmentAdmin from 'Component/DashboardQeza/Branch/BranchTreatmentAdmin';
import BranchDoctor from 'Component/DashboardQeza/Branch/BranchDoctor';

const DetailContainer = () => {
    // const { id } = useParams();
    const location = useLocation();
    const isClinicsRoute = location.pathname.includes('/clinics');
    const isDoctorsRoute = location.pathname.includes('/doctors');
    const isSettingsRoute = location.pathname.includes('/settings');
    const user = JSON.parse(localStorage.getItem('USER'));
    const id = user?.branch_id;
    const dispatch = useDispatch();
    const data = useSelector(state => state.branch.currentBranch);
    const startUpload = useSelector(state => state.branch.loading);
    const setupScheduleLoading = useSelector(state => state.setupSchedule.loading);
    const toggleModalTreatment = () => setModalTreatment(!modalTreatment);
    const [modalTreatment, setModalTreatment] = useState(false);
    const toggleModalDoctor = () => setModalDoctor(!modalDoctor);
    const [modalDoctor, setModalDoctor] = useState(false);
    const toggleModalSetup = () => setModalSetup(!modalSetup);
    const [modalSetup, setModalSetup] = useState(false);
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    const branchSchedule = useSelector((state) => state.branch.branchSchedule);
    const branchSetupSchedule = useSelector((state) => state.branch.branchSetupSchedule);
    const currentSetupSchedule = useSelector(state => state.setupSchedule.currentSetupSchedule)
    const history = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getBranchSchedule(id));
        dispatch(getSetupSchedule(id));
    }, [id]);

    const toggleTreatment = (item) => {
        setModalTreatment(true);        // Buka modal
    }

    const toggleDoctor = (item) => {
        setModalDoctor(true);        // Buka modal
    }

    const toggleSetup = (item) => {
        setModalSetup(true);        // Buka modal
    }

    const handleSubmitTreatment = (e) => {
        e.preventDefault();
        if (!currentBranch.treatment_id) {
            toast.error('Pilih layanan terlebih dahulu');
            return;
        }
        dispatch(attachTreatment({ ...currentBranch}));
        dispatch(setBranchFormData({ id: null }));
        setModalTreatment(false);
    }

    const handleSubmitDoctor = (e) => {
        e.preventDefault();
        if (!currentBranch.doctor_id) {
            toast.error('Pilih dokter terlebih dahulu');
            return;
        }
        dispatch(attachDoctor({ ...currentBranch}));
        dispatch(setBranchFormData({ id: null }));
        setModalDoctor(false);
    }

    const handleSubmitSetup = (e) => {
        e.preventDefault();
        if (!currentSetupSchedule.will_applied_at || !currentSetupSchedule.schedule_date || !currentSetupSchedule.hour_start_at || !currentSetupSchedule.hour_end_at || !currentSetupSchedule.quota) {
            toast.error('Lengkapi data terlebih dahulu');
            return;
        }
        // console.log(currentSetupSchedule, 'submit');
        dispatch(createSetupSchedule({ branch_id: id, data: currentSetupSchedule }));
        setModalSetup(false);
    }

    const handleDiscardTreatment = (e) => {
        e.preventDefault();
        resetBranchFormData();
        setModalTreatment(false);
    }

    const handleDiscardDoctor = (e) => {
        e.preventDefault();
        resetBranchFormData();
        setModalDoctor(false);
    }

    const handleDiscardSetup = (e) => {
        e.preventDefault();
        dispatch(resetScheduleFormData());
        setModalSetup(false);
    }

    const handleBack = () => {
        resetBranchFormData();
        history(`${process.env.PUBLIC_URL}/clinics`)
    }

    return (
        <Fragment>
            {(startUpload || setupScheduleLoading) && (
                <CustomLoader />
            )}
            <FormModal
                isOpen={modalTreatment}
                toggle={toggleModalTreatment}
                title={data.name}
                handleSubmit={handleSubmitTreatment}
                handleDiscard={handleDiscardTreatment}
            >
                {/* Bisa diisi dengan form apapun */}
                <AttachModal
                    label="Daftar Layanan Perawatan"
                    SelectComponent={<SelectTreatment />}
                />
            </FormModal>            
            <FormModal
                isOpen={modalDoctor}
                toggle={toggleModalDoctor}
                title={data.name}
                handleSubmit={handleSubmitDoctor}
                handleDiscard={handleDiscardDoctor}
            >
                {/* Bisa diisi dengan form apapun */}
                <AttachModal
                    label="Daftar Dokter"
                    SelectComponent={<SelectDoctor />}
                />
            </FormModal>            
            <FormModal
                isOpen={modalSetup}
                toggle={toggleModalSetup}
                title={`Atur Jadwal ${data.name}`}
                handleSubmit={handleSubmitSetup}
                handleDiscard={handleDiscardSetup}
            >
                {/* Bisa diisi dengan form apapun */}
                <AttachModal
                    SelectComponent={<SetupForm />}
                />
            </FormModal>            
            <DetailContent handleAttachTreatment={toggleTreatment} handleAttachDoctor={toggleDoctor} handleAttachSetup={toggleSetup} handleBack={handleBack} />
            { isSettingsRoute && (
                <>
                <ScheduleContent data={branchSchedule} />
                <ScheduleSetting schedules={branchSetupSchedule} />
                </>
            )}
            
            { isClinicsRoute && (
                <BranchTreatmentAdmin />
            )}

            { isDoctorsRoute && (
                <BranchDoctor />
            )}
        </Fragment>
    );
};

export default DetailContainer;